<template>
  <div class="psu_wrapper" v-loading="loading">
    <div class="container">
      <div class="main psu-dialog">
        <div class="lead">
          项目报名<span>(报名后，请点击右上角工作台处理后续工作。)</span>
        </div>
        <div class="psu">
          <div>
            <Nav
              v-if="false"
              :currentTab="tabIndex"
              :navs="navs"
              @change="navChange"
            ></Nav>
            <div class="line"></div>
          </div>
          <div class="form">
            <div class="row">
              <div class="label">项目名称</div>
              <div class="value">
                <span>{{ project.projectname }}</span>
              </div>
            </div>
            <!--v-if="tabIndex === 0 || tabIndex === 1"-->
            <div class="row">
              <div class="label">报名费</div>
              <div class="value">
                <span> ￥{{ setThousand(project.projectbmamt) }}元</span>
                （<amount :money="String(project.projectbmamt)" />）
                <!--<span v-if="psu.psuid && !bmPayFlag" style="color: red">（未支付）</span>-->
                <!--<span class="paybtn" v-if="psu.psuid && !bmPayFlag" @click="tabIndex = 1">去支付</span>-->
              </div>
              <div></div>
            </div>
            <div v-if="psu.psuid">
              <div class="row">
                <div class="label">支付凭证</div>
                <div class="value">
                  <!--报名费-->
                  <upload-pic-one
                    @changed="setBmPayFile"
                    :picUrl="psu.psubmpayurl"
                    folderName="web"
                    text="选择图片"
                  ></upload-pic-one>
                </div>
              </div>
            </div>
            <!--v-if="tabIndex === 0 || tabIndex === 2"-->
            <div class="row">
              <div class="label">保证金</div>
              <div class="value">
                <span> ￥{{ setThousand(project.projectbzjamt) }}元</span>
                （<amount :money="String(project.projectbzjamt)" />）
                <!--<span v-if="psu.psuid && !bzjPayFlag" style="color: red">（未支付）</span>-->

                <!--<span  class="paybtn" v-if="psu.psuid && !bzjPayFlag" @click="tabIndex = 2">去支付</span>-->
              </div>
            </div>
            <div v-if="psu.psuid">
              <div class="row">
                <div class="label">支付凭证</div>
                <div class="value">
                  <!--保证金-->
                  <upload-pic-one
                    @changed="setBzjPayFile"
                    :picUrl="psu.psubzjpayurl"
                    folderName="web"
                    text="选择图片"
                  ></upload-pic-one>
                </div>
              </div>
            </div>
            <!--v-if="tabIndex === 0"-->
              <!--<div class="row">-->
              <!--<div class="label">竞价要求内容</div>-->
              <!--<div class="value"><div class="content" v-html="project.prscontents"></div></div>-->
              <!--</div>-->
              <div class="row">
                <div class="label"><span class="redstar">*</span>联系姓名</div>
                <div class="value">
                  <el-input
                    placeholder="请输入联系姓名"
                    maxlength="20"
                    v-model.trim="psucontactname"
                    clearable
                  ></el-input>
                </div>
              </div>
              <div class="row">
                <div class="label"><span class="redstar">*</span>联系电话</div>
                <div class="value">
                  <el-input
                    placeholder="请输入联系电话"
                    maxlength="40"
                    v-model.trim="psucontactphone"
                    clearable
                  ></el-input>
                </div>
              </div>
              <div class="row">
                <div class="label"><span class="redstar">*</span>联系邮箱</div>
                <div class="value">
                  <el-input
                    placeholder="请输入联系邮箱"
                    maxlength="40"
                    v-model.trim="psucontactmail"
                    clearable
                  ></el-input>
                  <span style="color: #e91d1d; font-size: 12px"
                    >电子发票将发送此邮箱，务必填写准确！</span
                  >
                </div>
              </div>
              <div>
              <div class="row" v-if="+project.projectpfvisible === 1 && +this.project.prsbmneedconfirm === 1">
                <div class="label"><span class="redstar" v-if="+project.prsbmneedconfirm === 1">*</span>报名文件</div>
                <div>
                  <div>
                    <upload-btn @changed='setfile' text="上传报名文件"></upload-btn>
                  </div>
                  <div v-if="appendList.length" class="filelist">
                    <div v-for="(item,index) in appendList" :key="index" class="fileitem">
                      <div class="name" @click="downFile(item.appendurl)"><a :src="uploadAddr + item.appendurl">{{item.appendfilename}}</a></div>
                      <div class="delbtn" @click="delappend(item)"><span>删除</span></div>
                    </div>
                  </div>
              </div>
          </div>
              <!-- <div class="row">
                <div class="label"><span class="redstar">*</span>报名文件</div>
                <upload-btn
                  @changed="setfilebmfj"
                  text="上传报名文件"
                ></upload-btn>
              </div> -->
            </div>
            <!--v-if="tabIndex === 1"-->

            <!--v-if="tabIndex === 2"-->
          </div>
          <div class="footer">
            <div class="btn" v-if="!psu.psuid" @click="submit">提交报名</div>
            <div class="btn" v-else @click="submit">保存</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import request from "@/utils/request";
import utils from "../../assets/js/utils";
// import uploadBtn from '../common/uploadBtn'
import Nav from "../../components/common/Nav";
import uploadPicOne from "../common/UploadPicOne";
import amount from "../common/amount";
import uploadBtn from "../common/uploadBtn";
export default {
  name: "Psu",
  props: {
    projectid: {
      default: "",
    },
  },
  components: { Nav, uploadPicOne, amount, uploadBtn },
  data() {
    return {
      navs: ["报名信息"],
      tabIndex: 0,
      activeTab: 0,
      project: {},
      appendList: [],
      psu: {
        psuid: 0,
      },
      bmPayFlag: 0,
      bzjPayFlag: 0,
      userinfo: "",
      psucontactname: "",
      psucontactphone: "",
      psucontactmail: "",
      loading: false,
      bmappend: {
        appendid: 1,
      }
    };
  },
  created() {
    this.getProjectById();
  },
  // deactivated () {
  //   Object.assign(this.$data, {})
  // },
  methods: {
    setBmPayFile(path) {
      this.psu.psubmpayurl = path.replace(this.uploadAddr, "");
    },
    setBzjPayFile(path) {
      this.psu.psubzjpayurl = path.replace(this.uploadAddr, "");
    },
    navChange(val, tabIndex) {
      console.log(tabIndex);
      this.tabIndex = tabIndex;
      this.activeTab = tabIndex;
    },
    //获取当前用户名称
    async getuserinfo() {
      let res = await request({
        method: "get",
        url: "/xtgl/user/getUser",
        params: { userid: this.webLoginUser.userid },
      });
      this.psucontactname = res[0].username;
      this.psucontactphone = res[0].usercode;
      this.psucontactmail = res[0].useremail;
    },
    async submit() {
      if (!this.psucontactname) {
        this.$message.warning("请输入姓名！");
        return;
      }
      if (!this.psucontactphone) {
        this.$message.warning("请输入电话！");
        return;
      }
      if (!this.psucontactmail) {
        this.$message.warning("请输入邮箱！");
        return;
      }

      if (+this.webLoginUser.comtype !== 3) {
        this.$message.error("您不是供应商角色，不允许报名！");
        return;
      }
      if (this.project.projectpfvisible === 1 && +this.project.prsbmneedconfirm === 1) {
        if (this.appendList.length === 0) {
          this.$message.error("本项目报名时，需要提交报名文件！");
          return;
        }
      }
      // 报名前置拦截：当前供应商是否被本项目采购人(projectpcomid)列入黑名单
      if (this.project.projectpcomid) {
        let blk = await request({
          url: "/web/web/checkBlacklist",
          method: "get",
          params: {
            bltocomid: this.project.projectpcomid,
            blcomid: this.webLoginUser.comid,
          },
        });
        if (blk && blk.isBlack) {
          this.$message.error("报名单位被采购人列入黑名单，不允许参加采购人的项目采购。如有疑问，请联系公告中的项目联系人。");
          return;
        }
      }
      let model = {};
      if (!this.psu.psuid) {
        model = {
          cosid: this.cosId,
          psuid: 0,
          comtype: this.webLoginUser.comtype,
          psuprojectid: this.project.projectid,
          projectid: this.project.projectid,
          psutype: "1",
          psucomid: this.webLoginUser.comid,
          psuuserid: this.webLoginUser.userid,
          psustatus: this.project.prsbmneedconfirm === 1 ? "1" : "3",
          psubmamt: this.project.projectbmamt,
          psubzjamt: this.project.projectbzjamt,
          psubmpayuserid: null,
          psubmpaytime: null,
          psubmpayurl: null,
          psubmpaycheckuserid: null,
          psubmpaychecktime: null,
          psubzjpayuserid: null,
          psubzjpaytime: null,
          psubzjpayurl: null,
          psubzjpaycheckuserid: null,
          psubzjpaychecktime: null,
          psubidorder: null,
          psubidflg: null,
          psufeeamt: null,
          psuamt: null,
          psucontactname: this.psucontactname,
          psucontactphone: this.psucontactphone,
          psucontactmail: this.psucontactmail,
          psuconfirmuserid: null,
          psuconfirmtime: null,
          psuchargeflg: this.project.prschangeflg,
          appends: this.appendList,
          projectpfvisible: this.project.projectpfvisible,
          prsbmneedconfirm: this.project.prsbmneedconfirm,
          psupqcesresult: +this.project.prsflg === 6 ? 1 : null,
        };
        console.log(model)
        this.loading = true;
        let res = await request({
          url: "/web/web/savePsu",
          method: "post",
          data: model,
        });
        if (res.issuccess === 1) {
          this.$emit("change");
          // this.psu.psuid = res.data.psuid
          this.$message.success("您已报名");
          if (+this.project.prsbmneedconfirm === 1) {
            this.regNotice(model);
          }
          // this.$alert(`报名成功！`, '提示', {
          //   confirmButtonText: '关闭',
          //   type: 'warning'
          // }).then(() => {
          //   this.$emit('change')
          // }).catch(() => {
          // })
        } else {
          this.$message.error("报名失败");
        }
        this.loading = false;
      } else {
        model = {
          projectid: this.project.projectid,
          psuid: this.psu.psuid,
          psubmcheckdesc: this.psu.psubmcheckdesc || "",
          psustatus: this.project.prsbmneedconfirm === 1 ? "1" : "2",
          psubzjpayurl: this.psu.psubzjpayurl || "",
          psubmpayurl: this.psu.psubmpayurl,
          userid: this.webLoginUser.userid,
          appends: this.appendList
        };
        if (!this.psu.psubmpayurl) {
          this.$message({
            message: "请上传报名费支付凭证！",
            type: "warning",
          });
        }
        if (!this.psu.psubzjpayurl) {
          this.$message({
            message: "请上传保证金支付凭证！",
            type: "warning",
          });
          return;
        }
        let res = await request({
          url: "/web/web/savePsuConfirm",
          method: "post",
          data: model,
        });
        if (res.issuccess === 1) {
          if (this.psu.psubmpayurl) {
            this.bmPayFlag = 1;
          }
          if (this.psu.psubzjpayurl) {
            this.bzjPayFlag = 1;
          }
          this.$message.success("保存成功");
          this.$confirm(`报名信息已保存成功，是否关闭窗口?`, "提示", {
            confirmButtonText: "关闭",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$emit("change");
            })
            .catch(() => {});
        } else {
          this.$message.error("保存失败!" + res.msg);
        }
      }
    },
    async regNotice(model) {
      await request({
        url: "/web/web/regNotice",
        method: "post",
        data: model,
      });
    },
    delappend(file) {
      this.$confirm(`确定移除 ${file.appendfilename}？`, "提示", {
        type: "warning",
      })
        .then(() => {
          let index = this.appendList.findIndex(
            (val) => val.appendfilename === file.appendfilename
          );
          this.appendList.splice(index, 1);
        })
        .catch(() => {});
    },
    async setfile(path, filename) {
      let append = {
        appendid: 0,
        appendfromid: this.psu.psuid ? this.psu.psuid : 0,
        appendfromtype: "10",
        appendtype: "100",
        appendseq: this.appendList.length + 1,
        appendfilecode: "",
        appendfilename: filename,
        appendurl: path.replace(this.uploadAddr, ""),
      };
      this.appendList = []
      this.appendList.push(append);
    },
    setThousand(value) {
      return utils.comdify(value);
    },
    uploadAddr() {
      return this.$store.getters.picAddr;
    },
    async getProjectById() {
      this.loading = true;
      let res = await request({
        method: "get",
        url: "/web/web/getProjectById",
        params: { projectid: this.projectid },
      });
      this.project = res[0];
      let data = this.project.psuList.find(
        (v) => +v.psucomid === +this.webLoginUser.comid
      );
      if (data) {
        this.psu = data;
      }
      await this.getuserinfo();
      this.loading = false;
    },
  },
  computed: {
    ...mapGetters([
      "parentActiveTab",
      "childActiveTab",
      "cosId",
      "webLoginUser",
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

@media screen and (min-width: 1200px) {
  .redstar {
    color: red;
  }
  .psu_wrapper {
    .container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      .main {
        /*margin-top: 38px;*/
        /*padding: 23px 20px 40px;*/
        width: 100%;
        background-color: $color-bg-white;
        .line {
          height: 2px;
          border-bottom: 1px solid #eaeaea;
          div {
            border-bottom: 3px solid $color-orange;
            width: 65px;
          }
        }

        .active {
          div {
            border-bottom: 3px solid $color-orange;
            margin-left: 130px;
            width: 65px;
          }
        }
        .lead {
          border-left: 4px solid $color-orange;
          font-weight: bold;
          font-size: $fontsize-large-x;
          margin: 30px 0 30px;
          padding-left: 10px;
          display: flex;
          align-items: center;
          span {
            padding-left: 5px;
            font-weight: normal;
            font-size: $fontsize-medium;
            color: $color-red;
          }
        }
        .psu {
          padding-left: 14px;
          .nav {
            display: flex;
            .title {
              cursor: pointer;
              margin-right: 50px;
              padding-bottom: 18px;
              font-weight: bold;
              font-size: $fontsize-large;
            }
          }
          .form {
            font-size: $fontsize-medium;
            padding: 10px 0 60px;
            .row {
              display: flex;
              /*align-items: center;*/
              padding: 10px 0;
              width: 448px;
              align-items: center;
              .label {
                text-align: right;
                width: 100px;
                margin-right: 10px;
              }
              .value {
                flex: 1;
                span {
                  color: $color-text-secondary-gray;
                }
                .paybtn {
                  cursor: pointer;
                  border: 1px solid $color-orange;
                  padding: 1px 10px;
                  margin-left: 15px;
                  color: $color-orange;
                }
              }
              .content {
              }
              .yzmbtn {
                cursor: pointer;
                border: 1px solid $color-orange;
                padding: 11px;
                margin-left: 10px;
                color: $color-orange;
              }
              .filelist {
                /*width: 100%;*/
                padding-top: 10px;
                .fileitem {
                  display: flex;
                  text-align: left;
                  line-height: 40px;
                  .name {
                    color: #2f74ff;
                    cursor: pointer;
                    flex: 1;
                  }
                  .delbtn {
                    padding: 0 10px;

                    span {
                      color: #2f74ff;
                      cursor: pointer;
                    }
                  }
                  /*height: 150px;*/
                }
              }
            }
          }
          .footer {
            display: flex;
            justify-content: center;
            .btn {
              width: 318px;
              /*margin-left: 100px;*/
              text-align: center;
              border-radius: 40px;
              background-color: $color-orange;
              padding: 15px;
              font-size: $fontsize-large-x;
              color: #fff;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) and (min-width: 769px) {
  .redstar {
    color: red;
  }
  .psu_wrapper {
    .container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      .main {
        /*margin-top: 38px;*/
        /*padding: 23px 20px 40px;*/
        width: 100%;
        background-color: $color-bg-white;
        .line {
          height: 2px;
          border-bottom: 1px solid #eaeaea;
          div {
            border-bottom: 3px solid $color-orange;
            width: 65px;
          }
        }

        .active {
          div {
            border-bottom: 3px solid $color-orange;
            margin-left: 130px;
            width: 65px;
          }
        }
        .lead {
          border-left: 4px solid $color-orange;
          font-weight: bold;
          font-size: $fontsize-large-x;
          margin: 30px 0 30px;
          padding-left: 10px;
          display: flex;
          align-items: center;
          span {
            padding-left: 5px;
            font-weight: normal;
            font-size: $fontsize-medium;
            color: $color-red;
          }
        }
        .psu {
          padding-left: 14px;
          .nav {
            display: flex;
            .title {
              cursor: pointer;
              margin-right: 50px;
              padding-bottom: 18px;
              font-weight: bold;
              font-size: $fontsize-large;
            }
          }
          .form {
            font-size: $fontsize-medium;
            padding: 10px 0 60px;
            .row {
              display: flex;
              /*align-items: center;*/
              padding: 10px 0;
              width: 448px;
              align-items: center;
              .label {
                text-align: right;
                width: 100px;
                margin-right: 10px;
              }
              .value {
                flex: 1;
                span {
                  color: $color-text-secondary-gray;
                }
                .paybtn {
                  cursor: pointer;
                  border: 1px solid $color-orange;
                  padding: 1px 10px;
                  margin-left: 15px;
                  color: $color-orange;
                }
              }
              .content {
              }
              .yzmbtn {
                cursor: pointer;
                border: 1px solid $color-orange;
                padding: 11px;
                margin-left: 10px;
                color: $color-orange;
              }
              .filelist {
                /*width: 100%;*/
                padding-top: 10px;
                .fileitem {
                  display: flex;
                  text-align: left;
                  line-height: 40px;
                  .name {
                    color: #2f74ff;
                    cursor: pointer;
                    flex: 1;
                  }
                  .delbtn {
                    padding: 0 10px;

                    span {
                      color: #2f74ff;
                      cursor: pointer;
                    }
                  }
                  /*height: 150px;*/
                }
              }
            }
          }
          .footer {
            display: flex;
            justify-content: center;
            .btn {
              width: 318px;
              /*margin-left: 100px;*/
              text-align: center;
              border-radius: 40px;
              background-color: $color-orange;
              padding: 15px;
              font-size: $fontsize-large-x;
              color: #fff;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .redstar {
    color: red;
  }
  .psu_wrapper {
    .container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      .main {
        /*margin-top: 38px;*/
        /*padding: 23px 20px 40px;*/
        width: 100%;
        background-color: $color-bg-white;
        .line {
          height: 2px;
          border-bottom: 1px solid #eaeaea;
          div {
            border-bottom: 3px solid $color-orange;
            width: 65px;
          }
        }

        .active {
          div {
            border-bottom: 3px solid $color-orange;
            margin-left: 130px;
            width: 65px;
          }
        }
        .lead {
          border-left: 4px solid $color-orange;
          font-weight: bold;
          font-size: $fontsize-large-x;
          margin: 30px 0 30px;
          padding-left: 10px;
          display: flex;
          align-items: center;
          span {
            padding-left: 5px;
            font-weight: normal;
            font-size: $fontsize-medium;
            color: $color-red;
          }
        }
        .psu {
          padding-left: 14px;
          .nav {
            display: flex;
            .title {
              cursor: pointer;
              margin-right: 50px;
              padding-bottom: 18px;
              font-weight: bold;
              font-size: $fontsize-large;
            }
          }
          .form {
            font-size: $fontsize-medium;
            .row {
              display: flex;
              /*align-items: center;*/
              padding: 10px 0;
              align-items: center;
              .label {
                text-align: right;
                width: 5em;
              }
              .value {
                flex: 1;
                span {
                  color: $color-text-secondary-gray;
                }
                .paybtn {
                  cursor: pointer;
                  border: 1px solid $color-orange;
                  padding: 1px 10px;
                  margin-left: 15px;
                  color: $color-orange;
                }
              }
              .content {
              }
              .yzmbtn {
                cursor: pointer;
                border: 1px solid $color-orange;
                padding: 11px;
                margin-left: 10px;
                color: $color-orange;
              }
              .filelist {
                /*width: 100%;*/
                padding-top: 10px;
                .fileitem {
                  display: flex;
                  text-align: left;
                  line-height: 40px;
                  .name {
                    color: #2f74ff;
                    cursor: pointer;
                    flex: 1;
                  }
                  .delbtn {
                    padding: 0 10px;

                    span {
                      color: #2f74ff;
                      cursor: pointer;
                    }
                  }
                  /*height: 150px;*/
                }
              }
            }
          }
          .footer {
            display: flex;
            justify-content: center;
            .btn {
              width: 318px;
              /*margin-left: 100px;*/
              text-align: center;
              border-radius: 40px;
              background-color: $color-orange;
              padding: 15px;
              font-size: $fontsize-large-x;
              color: #fff;
            }
          }
        }
      }
    }
  }

}
</style>
